/** 閲覧申請：提案意向 未登録 */
export const VIEW_REQUEST_PROPOSAL_UNREGISTERED = {
    label: '未登録',
    value: null,
};
/** 閲覧申請：提案意向 辞退 */
export const VIEW_REQUEST_PROPOSAL_REFUSE = {
    label: '提案辞退',
    value: 0,
};
/** 閲覧申請：提案意向 登録済 */
export const VIEW_REQUEST_PROPOSAL_TODO = {
    label: '意向登録済',
    value: 1,
};
/** 閲覧申請：提案意向の一覧 */
export const VIEW_REQUEST_PROPOSALS = [
    VIEW_REQUEST_PROPOSAL_UNREGISTERED,
    VIEW_REQUEST_PROPOSAL_REFUSE,
    VIEW_REQUEST_PROPOSAL_TODO,
];
